import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { toast } from 'react-toastify';
import Spinner from './spinner';

const ForecastDetailsNew = () => {
  const currentYear = new Date().getFullYear();
  const availableYears = [currentYear, currentYear - 1, currentYear - 2];

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedQuarter, setSelectedQuarter] = useState(['Q1']);
  const [loading, setLoading] = useState(false);

  // Static data with more customers
  const [customers] = useState([
    { id: 1, name: 'TIGS PRINTER', total: '$1,959' },
    { id: 2, name: 'TIGS MODULE', total: '$739' },
    { id: 3, name: 'RETAIL SOLUTIONS', total: '$2,450' },
    { id: 4, name: 'BARCODE SYSTEMS', total: '$1,820' },
    { id: 5, name: 'TECH DISTRIBUTORS', total: '$3,100' },
    { id: 6, name: 'GLOBAL SUPPLIES', total: '$890' },
    { id: 7, name: 'OFFICE DEPOT', total: '$2,670' },
    { id: 8, name: 'ENTERPRISE TECH', total: '$4,200' },
  ]);

  const [subCategories] = useState({
    1: [
      { name: 'CP', values: {} },
      { name: 'LABEL', values: {} },
      { name: 'MOBILE', values: {} },
      { name: 'OTHER', values: {} },
      { name: 'PARTS', values: {} },
      { name: 'NEW BUSINESS', values: {} },
    ],
    2: [
      { name: 'HARDWARE', values: {} },
      { name: 'SOFTWARE', values: {} },
      { name: 'SERVICES', values: {} },
    ],
    3: [
      { name: 'POS SYSTEMS', values: {} },
      { name: 'SCANNERS', values: {} },
      { name: 'ACCESSORIES', values: {} },
    ],
    4: [
      { name: 'THERMAL', values: {} },
      { name: 'INKJET', values: {} },
      { name: 'LABELS', values: {} },
    ],
    5: [
      { name: 'ENTERPRISE', values: {} },
      { name: 'SMB', values: {} },
    ],
    6: [
      { name: 'CONSUMABLES', values: {} },
      { name: 'PARTS', values: {} },
    ],
    7: [
      { name: 'RETAIL', values: {} },
      { name: 'CORPORATE', values: {} },
      { name: 'GOVERNMENT', values: {} },
    ],
    8: [
      { name: 'CLOUD', values: {} },
      { name: 'ON-PREMISE', values: {} },
      { name: 'HYBRID', values: {} },
    ],
  });

  const monthMap = {
    '04': 'Apr', '05': 'May', '06': 'Jun',
    '07': 'Jul', '08': 'Aug', '09': 'Sep',
    '10': 'Oct', '11': 'Nov', '12': 'Dec',
    '01': 'Jan', '02': 'Feb', '03': 'Mar'
  };

  const getMonthsForQuarters = (quarters, year) => {
    const quarterMonths = {
      Q1: ['04', '05', '06'],
      Q2: ['07', '08', '09'],
      Q3: ['10', '11', '12'],
      Q4: ['01', '02', '03']
    };

    let months = [];
    quarters.forEach(q => {
      if (quarterMonths[q]) {
        quarterMonths[q].forEach(month => {
          const actualYear = (q === 'Q4') ? parseInt(year) + 1 : year;
          months.push({
            key: `${actualYear}-${month}`,
            label: monthMap[month],
            month: month,
            year: actualYear
          });
        });
      }
    });
    return months;
  };

  const [monthHeaders, setMonthHeaders] = useState(getMonthsForQuarters(['Q1'], currentYear));

  useEffect(() => {
    const months = getMonthsForQuarters(selectedQuarter, selectedYear);
    setMonthHeaders(months);
  }, [selectedYear, selectedQuarter]);

  const handleSearch = () => {
    toast.info('Search functionality - API integration pending');
  };

  const columnGroups = [
    { label: 'FCB', color: '#FFFFFF' },
    { label: 'vs FCB', color: '#FFFFFF' },
    { label: 'Dec-24', color: '#FFFFFF' },
    { label: 'vs 24B', color: '#FFFFFF' },
    { label: 'FC9', color: '#FFFFFF' },
    { label: 'Firm PO', color: '#FFFF00' },
    { label: 'Firm PO Risk', color: '#FFFF00' },
    { label: 'Low Risk', color: '#FFFF00' },
    { label: 'High Risk', color: '#FFFF00' },
    { label: 'Mark up Historical', color: '#FFFF00' },
    { label: '2025 MTBF', color: '#FFFF00' },
    { label: 'vs 2025 MTBF', color: '#FFFF00' },
    { label: 'FCB', color: '#FFFFFF' },
    { label: 'vs FCB', color: '#FFFFFF' },
    { label: '24B 3Q', color: '#FFFFFF' },
    { label: 'vs 24B', color: '#FFFFFF' },
  ];

  return (
    <div className="p-4 bg-[#f9fafb]">
      <h2 className="text-2xl font-bold mb-4">Budget, Forecast & Actuals</h2>

      <div className="bg-white p-4 rounded-lg shadow-md mb-4">
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
          <div>
            <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Year:</label>
            <select 
              value={selectedYear} 
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              style={{
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                fontSize: '14px',
                cursor: 'pointer',
                minWidth: '120px'
              }}
            >
              {availableYears.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Quarter:</label>
            <Select
              mode="multiple"
              placeholder="Select Quarter(s)"
              value={selectedQuarter}
              onChange={(values) => setSelectedQuarter(values)}
              style={{ width: 280 }}
              options={[
                { label: 'Q1 (Apr-Jun)', value: 'Q1' },
                { label: 'Q2 (Jul-Sep)', value: 'Q2' },
                { label: 'Q3 (Oct-Dec)', value: 'Q3' },
                { label: 'Q4 (Jan-Mar)', value: 'Q4' },
              ]}
            />
          </div>

          <div>
            <button
              onClick={handleSearch}
              className="bg-[#3D3D3D] text-white px-6 py-2 rounded-md cursor-pointer hover:bg-[#2D2D2D]"
              style={{ height: '40px' }}
            >
              <span className="text-white">Search</span>
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-10">
          <Spinner />
        </div>
      ) : (
        <div className="bg-white p-4 rounded-lg shadow-md">
          <div 
            className="overflow-auto" 
            style={{ 
              maxHeight: 'calc(100vh - 300px)',
              overflowX: 'auto',
              overflowY: 'auto'
            }}
          >
            <table className="min-w-full border-collapse border border-gray-300" style={{ fontSize: '12px' }}>
              <thead className="sticky top-0 z-20">
                <tr className="bg-[#FFFF00]">
                  <th 
                    className="border border-gray-300 px-2 py-1 text-left sticky left-0 bg-[#00FFFF] z-30" 
                    style={{ minWidth: '150px' }}
                  >
                    Customer
                  </th>
                  <th 
                    className="border border-gray-300 px-2 py-1 text-center sticky left-[150px] bg-[#00FFFF] z-30" 
                    style={{ minWidth: '80px' }}
                  >
                    Status
                  </th>
                  {monthHeaders.map((month, idx) => (
                    <th 
                      key={idx} 
                      colSpan={columnGroups.length}
                      className="border border-gray-300 px-2 py-1 text-center bg-[#FFFF00]"
                    >
                      {month.label}-{month.year.toString().slice(-2)}
                    </th>
                  ))}
                </tr>

                <tr className="bg-[#E0E0E0] sticky top-[40px] z-20">
                  <th 
                    className="border border-gray-300 px-2 py-1 sticky left-0 bg-[#00FFFF] z-30"
                  ></th>
                  <th 
                    className="border border-gray-300 px-2 py-1 sticky left-[150px] bg-[#00FFFF] z-30"
                  ></th>
                  {monthHeaders.map((month, mIdx) => (
                    <React.Fragment key={mIdx}>
                      {columnGroups.map((col, cIdx) => (
                        <th 
                          key={`${mIdx}-${cIdx}`}
                          className="border border-gray-300 px-2 py-1 text-center text-xs"
                          style={{ 
                            backgroundColor: col.color,
                            minWidth: '70px',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {col.label}
                        </th>
                      ))}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody>
                {customers.map((customer, custIdx) => {
                  const subCats = subCategories[customer.id] || [];
                  const rowCount = subCats.length > 0 ? subCats.length + 1 : 1;

                  return (
                    <React.Fragment key={customer.id}>
                      <tr className="bg-white hover:bg-gray-50 font-bold">
                        <td 
                          className="border border-gray-300 px-2 py-2 sticky left-0 bg-white z-10"
                          rowSpan={rowCount}
                        >
                          {customer.name}
                        </td>
                        <td 
                          className="border border-gray-300 px-2 py-2 text-center sticky left-[150px] bg-white z-10"
                        >
                          TOTAL
                        </td>
                        {monthHeaders.map((month, mIdx) => (
                          <React.Fragment key={mIdx}>
                            {columnGroups.map((col, cIdx) => {
                              const isNegative = Math.random() > 0.7;
                              const value = `$${Math.floor(Math.random() * 5000)}`;
                              return (
                                <td 
                                  key={`${mIdx}-${cIdx}`}
                                  className="border border-gray-300 px-2 py-2 text-right"
                                  style={{ 
                                    color: isNegative ? 'red' : 'black',
                                    backgroundColor: col.color === '#FFFF00' ? '#FFFACD' : '#FFFFFF'
                                  }}
                                >
                                  {isNegative ? `(${value})` : value}
                                </td>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      </tr>

                      {subCats.map((subCat, subIdx) => (
                        <tr key={`${customer.id}-${subIdx}`} className="bg-white hover:bg-gray-50">
                          <td 
                            className="border border-gray-300 px-2 py-1 text-sm sticky left-[150px] bg-white z-10"
                          >
                            {subCat.name}
                          </td>
                          {monthHeaders.map((month, mIdx) => (
                            <React.Fragment key={mIdx}>
                              {columnGroups.map((col, cIdx) => {
                                const isNegative = Math.random() > 0.8;
                                const value = Math.random() > 0.5 ? `$${Math.floor(Math.random() * 1000)}` : '$0';
                                return (
                                  <td 
                                    key={`${mIdx}-${cIdx}`}
                                    className="border border-gray-300 px-2 py-1 text-right text-sm"
                                    style={{ 
                                      color: isNegative ? 'red' : 'black',
                                      backgroundColor: col.color === '#FFFF00' ? '#FFFACD' : '#FFFFFF'
                                    }}
                                  >
                                    {isNegative ? `(${value})` : value}
                                  </td>
                                );
                              })}
                            </React.Fragment>
                          ))}
                        </tr>
                      ))}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForecastDetailsNew;




